"use-client";

import { isWindowPresent } from "src/utils/browserHelpers";

export const DOMAIN =
  process.env.APP_ENV === "dev"
    ? "http://localhost:3000"
    : isWindowPresent
    ? window.location.origin || "https://www.cleartrip.com"
    : "";

export const baseURL = `${DOMAIN}/api/bus/v1`;
export const baseURLV2 = `${DOMAIN}/api/bus/v2`;
export const FASTUI_DOMAIN = "https://fastui.cltpstatic.com";

export const Rs = "₹";

export const DEFAULT_SORT = "top_rated";
export const DEFAULT_DX = "3";

export const departureValues = {
  earlyMorning: { start: "0", end: "6" },
  morning: { start: "6", end: "12" },
  afternoon: { start: "12", end: "18" },
  night: { start: "18", end: "23.59" },
};

export enum FLOW {
  "PRE" = "pre",
  "POST" = "post",
}

export const SUPERCOIN_KNOW_MORE_LINK =
  "https://www.cleartrip.com/lp/supercoin";

export enum Error {
  RESERVED_FOR_FEMALE = "This seat is reserved for female travellers",
  RESERVED_FOR_MALE = "This seat is reserved for male travellers",
  SOMETHING_WENT_WRONG = "Something went wrong. Please try again",
  ADULT_REQUIRED = "At least one traveller should be over the age of 12",
  SEAT_NOT_AVAILABLE = "Your previously selected seats are no longer available. Select seats again",
}

export const supportMobNo = 9595333333;

export enum RefundReasons {
  CANCELLED = "Booking cancelled",
  FAILED = "Booking failed",
  PAYMENT_FAILED = "Payment failed",
}

export const CFNR_LOGO =
  "https://static-assets-ct.flixcart.com/ct/assets/resources/images/bus/BUS_CFNR_LOGO.svg";

export const CFNR_LOGO_WHITE =
  "https://static-assets-ct.flixcart.com/ct/assets/resources/images/bus/BUS_CFNR_LOGO_WHITE.svg";
export enum CFNRConfig {
  minimumBookingValue = 300,
  cancelDuration = 360,
}

export const CFNR_KNOW_MORE_LINK =
  "https://offers.cleartrip.com/bus-clearchoicemax/";

export enum ADD_ONS {
  BUS_PASS = "BUS_PASS",
}
